import Modal from '../modal/modal.ts'
import { Nullable } from '../../types/common.ts'
import Lookbook from './index'

class LookbookModal extends Modal {
  lookbookSelector: string

  lookbook: Nullable<Lookbook>

  constructor() {
    super()

    this.lookbookSelector = 'lookbook-component'

    this.lookbook = this.closest(this.lookbookSelector)
  }

  async show(): Promise<void> {
    await super.show()

    if (!this.lookbook) {
      return
    }

    const highlightedBlockId = this.lookbook.highlightedBlockId

    this.lookbook.showBlockById(highlightedBlockId)
  }
}

export default LookbookModal
